import React, { useEffect, useState } from "react";
import { Column } from "@amzn/meridian";
import CameraFrame from "../../inspection/cameraFrame";
import { useAppDispatch } from "src/store/store";
import { setStreamingMode, resetStreamingState } from "src/store/inspectionCaptureSlice";
import { setShownHumanText } from "src/store/workflowSlice";
import StepTransitionSheet from "./StepTransitionSheet";

interface DetectObjectStepProps {
  humanText: string;
  target: string[];
  backend: {
    type: string;
    question_ids: string[];
  };
  onComplete: () => void;
}

const DetectObjectStep: React.FC<DetectObjectStepProps> = ({
  humanText,
  target,
  onComplete,
}) => {
  const dispatch = useAppDispatch();
  const [stepComplete, setStepComplete] = useState(false);

  useEffect(() => {
    dispatch(setShownHumanText(humanText));
    return () => {
      dispatch(resetStreamingState());
    };
  }, [dispatch, humanText]);

  return (
    <Column height="100vh">
      <CameraFrame
        onCapture={() => setStepComplete(true)}
        targetClasses={target}
        key={humanText}
      />
      { stepComplete && <StepTransitionSheet
        headerMessage="Photo Uploaded!"
        message="AI analysis running in background. Moving to next step."
        onClose={onComplete}
      />}
    </Column>
  );
};

export default DetectObjectStep;
